import React, { FC } from 'react';
import styles from './Error.module.scss';
import { FormikErrors } from 'formik';

interface ErrorMessageProps {
  message: string | undefined | FormikErrors<string>;
}

const ErrorMessage: FC<ErrorMessageProps> = ({ message }) => {
  return <div className={styles.inputError}>{message}</div>;
};

export default ErrorMessage;
